import { render, staticRenderFns } from "./CommunicationPreferencesForm.vue?vue&type=template&id=87bcea58"
import script from "./CommunicationPreferencesForm.vue?vue&type=script&lang=js"
export * from "./CommunicationPreferencesForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports